import React from 'react'

const AboutParagraph = () => {
  return (
    <div className='text-white mx-auto flex max-w-4xl items-center justify-center  p-4 lg:px-8 mt-24'>
        <h1 className=' text-white mt-40 text-6xl text-center font-normal'> I love making cool things and solving complex problems for people — like you. 😊</h1>
    </div>
  )
}

export default AboutParagraph